/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown>, amount: NonNullable<unknown> }} Directory_Vibebids_Claim_RankInputs */

const en_directory_vibebids_claim_rank = /** @type {(inputs: Directory_Vibebids_Claim_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Claim #${i?.rank} for $${i?.amount}`)
};

const zh_directory_vibebids_claim_rank = /** @type {(inputs: Directory_Vibebids_Claim_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`以 $${i?.amount} 抢占 #${i?.rank}`)
};

/**
* | output |
* | --- |
* | "Claim #{rank} for ${amount}" |
*
* @param {Directory_Vibebids_Claim_RankInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_claim_rank = /** @type {((inputs: Directory_Vibebids_Claim_RankInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Claim_RankInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_claim_rank(inputs)
	return zh_directory_vibebids_claim_rank(inputs)
});
export { directory_vibebids_claim_rank as "directory.vibebids.claim_rank" }